/* マガジン記事の目次（Contents）を本文中の H2 から自動生成する */
(function () {
  function buildToc(root) {
    var body = root.querySelector('[data-magazine-body]');
    var wrap = root.querySelector('[data-magazine-toc]');
    var list = root.querySelector('[data-magazine-toc-list]');
    if (!body || !wrap || !list) return;

    var headings = body.querySelectorAll('h2');
    if (!headings.length) {
      wrap.hidden = true;
      return;
    }

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = 'magazine-section-' + (index + 1);
      }
      var item = document.createElement('li');
      item.className = 'magazine-toc__item';

      var link = document.createElement('a');
      link.className = 'magazine-toc__link';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;

      item.appendChild(link);
      list.appendChild(item);
    });
  }

  function init() {
    document.querySelectorAll('[data-magazine-article]').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
